<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M15.798 22H8.202a.862.862 0 0 1-.593-.242l-5.367-5.376A.826.826 0 0 1 2 15.79V8.202c0-.225.092-.434.242-.593l5.376-5.367A.826.826 0 0 1 8.21 2h7.588c.225 0 .434.092.593.242l5.367 5.367a.826.826 0 0 1 .242.593v7.588a.862.862 0 0 1-.242.592L16.39 21.75a.826.826 0 0 1-.593.242V22Zm-7.245-1.67h6.903l4.875-4.874V8.553l-4.875-4.875H8.553L3.669 8.553v6.903l4.875 4.875h.009Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
